function normalizePath(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith('/')) return pathname.slice(0, -1)
  return pathname
}

function doesRoutePathMatch(pathname: string, routePathPattern: string): boolean {
  const p = normalizePath(pathname)
  const pat = normalizePath(routePathPattern)

  if (pat === '*') return true

  const pSeg = p.split('/').filter(Boolean)
  const patSeg = pat.split('/').filter(Boolean)

  for (let i = 0; i < patSeg.length; i++) {
    const patPart = patSeg[i]
    const pPart = pSeg[i]

    if (patPart === '*') return true
    if (pPart == null) return false
    if (patPart.startsWith(':')) continue
    if (patPart !== pPart) return false
  }

  return pSeg.length === patSeg.length
}

function shouldDisableLayoutConstraints(
  pathname: string,
  routesToDisable?: LayoutUtils.LayoutRouteLike[]
): boolean {
  if (!routesToDisable?.length) return false
  return routesToDisable.some((r) => doesRoutePathMatch(pathname, r.path))
}

export {
    normalizePath,
    doesRoutePathMatch,
    shouldDisableLayoutConstraints
}